<template>
  <FriedModal @close="handleClose">
    <template #header>
      <FriedModalHeader :header="headerText" />
    </template>
    <div class="modal-content">
      <div id="reject-confirm">
        <div class="reject-confirm-text">
          {{ $t('confirm-reject-document') }}
        </div>
        <!-- Un comment this when reject reason is available in back end
          <div class="reject-reason">
          <div>{{ $t('reason') }}</div>
          <textarea
            ref="input"
            v-model="reasonText"
            :placeholder="$t('reject-reason-description')"
            class="text-input"
          />
        </div> -->
      </div>
    </div>
    <template #footer>
      <FriedModalButtonsFooter v-if="!isRejected">
        <FriedButton
          class="cancel-button"
          data-external="reject-modal-cancel-button"
          :button-type="ButtonType.Secondary"
          @click="handleClose"
        >
          {{ $t('cancel') }}
        </FriedButton>
        <FriedButton
          class="reject-button"
          data-external="reject-modal-decline-button"
          :loading="isLoading"
          @click="handleReject"
        >
          {{ $t('reject-deal') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import { computed, defineComponent, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    isRejected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const reasonText = ref('');
    const isLoading = ref(false);

    const headerText = computed((): string =>
      props.isRejected ? t('document-successfully-rejected!') : t('reject-document')
    );
    const watchIsRejected = () => {
      if (props.isRejected) {
        isLoading.value = true;
      }
    };
    watch(() => props.isRejected, watchIsRejected);

    const handleReject = () => {
      isLoading.value = true;
      emit('rejectDocument', reasonText.value);
    };

    const handleClose = () => {
      emit('close');
    };

    return {
      ButtonType,
      reasonText,
      isLoading,
      headerText,
      watchIsRejected,
      handleReject,
      handleClose,
    };
  },
});
</script>
<style lang="scss" scoped>
.modal-header {
  text-align: left;
  font-weight: bold;
  height: auto;
  padding: 0;
  line-height: inherit;
}

.modal-content {
  flex-direction: column;
  flex-grow: 2;
  justify-content: flex-start;
  padding: 0;

  .reject-confirm-text {
    margin-bottom: var(--spacing-150);
    font-size: var(--paragraph-medium-font-size);
  }

  .reject-reason {
    font-size: 12px;
    color: var(--text-gray);
  }

  .text-input {
    outline: none;
    resize: none;
    color: var(--text-gray);
    min-height: 150px;
    width: 100%;
    margin-top: var(--spacing-50);
    border: 1px solid var(--gray-96);
    box-sizing: border-box;
    border-radius: var(--radius-small);
    padding: var(--spacing-100);
    font-size: var(--paragraph-medium-font-size);
    font-weight: 400;

    @media only screen and (max-width: $xs) {
      min-height: 300px;
    }
  }
}

:deep(.ga-modal-container) {
  > .ga-modal-footer {
    @media only screen and (max-width: $xs) {
      display: flex;
      flex-direction: column-reverse;

      .ga-button {
        width: 100%;
        flex-direction: row;
        justify-content: center;
        margin-bottom: var(--spacing-100);
      }
    }
  }
}
</style>
